import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAllDisputes, updateDisputeStatus, deleteDispute } from 'services/disputesService';

export const fetchDisputes = createAsyncThunk(
    'disputes/fetchDisputes',
    async (params, { rejectWithValue }) => {
        try {
            const response = await getAllDisputes(params);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const updateDispute = createAsyncThunk(
    'disputes/updateDispute',
    async ({ id, status }, { rejectWithValue }) => {
        try {
            const response = await updateDisputeStatus(id, status);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const removeDispute = createAsyncThunk(
    'disputes/removeDispute',
    async (id, { rejectWithValue }) => {
        try {
            await deleteDispute(id);
            return id;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

const disputesSlice = createSlice({
    name: 'disputes',
    initialState: {
        items: [],
        loading: false,
        error: null,
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0,
        },
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDisputes.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchDisputes.fulfilled, (state, action) => {
                state.loading = false;
                state.items = action.payload.items;
                state.pagination.current = action.payload.currentPage;
                state.pagination.total = action.payload.totalItems;
            })
            .addCase(fetchDisputes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateDispute.fulfilled, (state, action) => {
                const index = state.items.findIndex(d => d._id === action.payload._id);
                if (index !== -1) {
                    state.items[index] = action.payload;
                }
            })
            .addCase(removeDispute.fulfilled, (state, action) => {
                state.items = state.items.filter(d => d._id !== action.payload);
            });
    },
});

export default disputesSlice.reducer;
